"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByCategorySummary_1 = __importDefault(require("./SalesByCategorySummary"));
class SalesByCategorySummaryData {
    constructor({ label, summaries }) {
        this.toJSON = () => ({
            label: this.label,
            summaries: this.summaries,
        });
        this.label = label;
        this.summaries = summaries;
    }
}
SalesByCategorySummaryData.fromJSON = (json) => {
    const { label, summaries } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (!Array.isArray(summaries))
        throw new Error('.summaries must be an array');
    const _summaries = summaries.map(item => SalesByCategorySummary_1.default.fromJSON(item));
    return new SalesByCategorySummaryData({
        label,
        summaries: _summaries,
    });
};
exports.default = SalesByCategorySummaryData;
